import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Scrollbar, SpinnerLoader, Tabs, Typography } from 'shared/ui'
import { SurveyStatus } from 'entities/Surveys'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ISurveyCommonData } from 'entities/Surveys/model/types'
import { DetailsSurveyModalStore } from 'pages/surveys/ui/actions/detailsSurvey/store/detailsSurveyModalStore'
import { ContactEnrollmentTab } from './ContactEnrollmentTab'
import styles from './styles.module.scss'
import { ScoreElaborationTab } from './ScoreElaborationTab/ScoreElaborationTab'
import { ClosingMessageTab } from './ClosingMessageTab/ClosingMessageTab'
import { ActionsTab } from './ActionsTab/ActionsTab'

type IDetailsSurveyModalContentProps = {
  store: DetailsSurveyModalStore
  data: ISurveyCommonData
}

const DetailsSurveyModalContent = observer(({ store, data }: IDetailsSurveyModalContentProps) => {
  const { loading, tabs, activeTabKey, setActiveTab } = store

  return (
    <div className={styles.wrap}>
      <Box padding={'0 24px'} display={'flex'}>
        <Typography ariaLabel={'SurveyDetailsName'} variant={'heading-lg'} ellipsis>
          {data.name}
        </Typography>
      </Box>
      <div className={styles.status}>
        <SurveyStatus status={data.status} />
      </div>

      {loading ? (
        <SpinnerLoader ariaLabel={'DetailsSurveyModal'} />
      ) : (
        <Box height={'100%'}>
          <Box padding={'0 18px'}>
            <Tabs tabs={tabs} activeTabKey={activeTabKey} handleSelectTab={setActiveTab} />
          </Box>
          <Scrollbar autoHeight autoHeightMax={'calc(100% - 28px)'}>
            {activeTabKey === 'contactEnrollment' && <ContactEnrollmentTab store={store} />}
            {activeTabKey === 'scoreElaboration' && <ScoreElaborationTab store={store} />}
            {activeTabKey === 'closingMessage' && <ClosingMessageTab store={store} />}
            {activeTabKey === 'actions' && <ActionsTab store={store} />}
          </Scrollbar>
        </Box>
      )}
    </div>
  )
})

type IDetailsSurveyModalProps = {
  data: ISurveyCommonData
}

export const DetailsSurveyModal = observer(({ data }: IDetailsSurveyModalProps) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new DetailsSurveyModalStore(data.id, entities))

  return <DetailsSurveyModalContent data={data} store={store} />
})
